import React, { memo, useCallback, useContext, useState } from 'react'

import { Button, CircleCheck, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'

import AccessCodeForm from 'Pods/Shared/Waitlist/AccessCodeForm/AccessCodeForm'
import { iconSizeMedium } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import applyAccessCodeResult from 'Pods/ThreeDStudio/Shared/Utils/applyAccessCodeResult'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

import AiTermsNotice from '../AiTermsNotice/AiTermsNotice'
import UpgradeCard from '../UpgradeCard/UpgradeCard'

function WaitlistedBody({ onClose: handleClose }) {
  const t = useTranslation()
  const { locale } = useContext(ThreeDStudioPageContext)
  const [isCodeFormOpen, setIsCodeFormOpen] = useState(false)

  const handleToggleCodeForm = useCallback(() => {
    setIsCodeFormOpen(prev => !prev)
  }, [])

  return (
    <div className="usage-modal__waitlisted">
      <div className="usage-modal__waitlisted-headline">
        <Icon svgComponent={CircleCheck} color="positive" size={iconSizeMedium} notSpaced />
        <p className="cgt-heading-200">{t('usageModal.waitlisted.onWaitlist')}</p>
      </div>
      <p className="usage-modal__waitlisted-copy cgt-body-md">
        {t('usageModal.waitlisted.copy')}
      </p>

      <Button
        size="small"
        type="secondary"
        customClass="usage-modal__waitlisted-code-toggle"
        onClick={handleToggleCodeForm}
      >
        {t('usageModal.waitlisted.accessCode')}
      </Button>
      {isCodeFormOpen && (
        <>
          <AccessCodeForm onApplied={applyAccessCodeResult} onClose={handleClose} locale={locale} />
          <AiTermsNotice small leadTextKey="usageModal.terms.leadWaitlisted" />
        </>
      )}

      <UpgradeCard onClose={handleClose} title={t('usageModal.waitlisted.upgradeTitle')} />
    </div>
  )
}

WaitlistedBody.propTypes = {
  onClose: func.isRequired,
}

export default memo(WaitlistedBody)
